export const isFlagSetIn = (flags: number[], source: number): boolean => {
  for(let i = 0; i < flags.length; i++) {
    if((flags[i] & source) === flags[i]) {
      return true;
    }
  }
  return false;
}
